import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { createExclusion, updateExclusion } from '../../lib/apiClient';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Alert } from 'react-bootstrap';
import AlertMessage from '../Common/Alert';
import TrafficSearch from '../TrafficSearch';



const SaveAsExclusion = observer((props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);
    const typeRef = useRef(null);    
    const [validated, setValidated] = useState(false);
    const criteria = props.store.TrafficStore.userDefinedCriteria;
    const [formData, setFormData] = useState({
        buckets: ["*"],
        criteria: '',
        description: '',
        environments: ["*"],
        enabled : true
      });

    useEffect(() => {
        formRef.current?.reset();
        setIsSubmitting(false);

        if(props.exclusion){
            // setup the defaults...
            const defaults = {
                buckets: props.exclusion?.buckets || ["*"],
                criteria: props.exclusion.pattern,
                description: props.exclusion.description,
                environments: props.exclusion.environments.length ? props.exclusion.environments : ["*"],
                enabled : props.exclusion?.enabled,
            }
            
            typeRef.current.value = defaults.type;
            setFormData(defaults);
        }
    // eslint-disable-next-line
    }, [props.exclusion]);

    const handleEnvironmentsChange = (event) => {
        const { value, checked } = event.target;

        let newArray = [];

        if(value === "*" && checked){
            newArray.push("*");
            setFormData({...formData, environments: newArray});
        }else if(value !== "*" && checked){
            newArray = formData.environments;
            newArray.push(value);
            setFormData({...formData, environments: newArray});
        }else if(!checked){
            let newArr = formData.environments.filter(scope => scope !== value);
            if(value !== '*' && newArr.length === 0){
                newArr.push("*");
            }
            setFormData({...formData, environments: newArr});
        }
      };
    const handleBucketChange = (event) => {
        const { value, checked } = event.target;

        let newArray = [];
        console.log(value, checked );
        if(value === "*" && checked){
            newArray.push("*");
            setFormData({...formData, buckets: newArray});
        }else if(value !== "*" && checked){
            newArray = formData.buckets;
            newArray.push(value);
            setFormData({...formData, buckets: newArray});
        }else if(!checked){
            let newArr = formData.buckets.filter(scope => scope !== value);
            if(value !== '*' && newArr.length === 0){
                newArr.push("*");
            }
            setFormData({...formData, buckets: newArr});
        }
    };

    
    const handleSubmit = async (event)  => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
          setIsSubmitting(false);
        }
        
        setValidated(true);
        

        event.preventDefault();
        event.stopPropagation();
            
        const params = {
          accountSid: props.store.SessionStore.getAccountSid(),
          exclusionSid: props.exclusion?.sid || null,
          buckets: formData.buckets,
          criteria: criteria,
          description: formData.description.length ? formData.description : null,
          environments: formData.environments,
          enabled: formData.enabled
        }
        
        setIsSubmitting(true);

        let response;
        if(!params.exclusionSid){
            response = await createExclusion(params);
        }else{
            response = await updateExclusion(params);
        }
        
    
        if(response.successful){
            if(props.onComplete){
                props.onComplete(response.data);
            }            
            handleClose();
        }else{
            setIsSubmitting(false);
        }
      };

    const handleClose = () => {
      //console.log(errors);
      formRef.current?.reset();
      props.close();
      setIsSubmitting(false);
    };

    const renderButtons = ()=>{
        return(
            <>
                <Button variant="secondary" onClick={props.close} className="me-2">
                    Cancel
                </Button>

                {!isSubmitting ? (
                    <Button variant="primary" type="submit">
                        {props.exclusion ? ('Update') : ('Create')}
                    </Button>
                    ) : (
                    <Button variant="primary" type="submit" disabled>
                        <span className="spinner-border me-2" role="status" aria-hidden="true"></span> {props.exclusion ? ('Updating') : ('Creating')}...
                    </Button>
                )}
            </>
        );
    }
   
  return (
    <>
        <Alert variant='primary'>
            Creating this exclusion will stop your API from sending request data for any requests that match the criteria shown below. 
        </Alert>

        <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
            <h5 className="my-6">Criteria</h5>
            <TrafficSearch {...props} view={props.view} readOnly={true}  />


            <h5 className="my-6 mt-3">General</h5>
            <Form.Group className="mb-3" controlId="description">
                <Form.Label>Description</Form.Label>
                <Form.Control type="text" name="description" defaultValue={formData.description}  placeholder="Name/Description" />
                <Form.Control.Feedback type="invalid">
                    A description is required.
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                    Provide a description for this exclusion to make it easier to understand later.
                </Form.Text>
            </Form.Group>

            <hr/>
            
            <h5 className="my-6">Targeting</h5>

            <div className="row">
                <div className="col mb-3">
                    <label className="form-label">Buckets*</label>
                </div>
            </div>

            <div className="row">
                <div className="col mb-3 ms-3">
                    <Form.Check // prettier-ignore
                            type="switch"
                            id="all-buckets"
                            value="*"
                            defaultChecked={formData.buckets.includes("*")}
                            label="Apply to all"
                            onChange={handleBucketChange} />
                </div>
            </div>
                {!formData.buckets.includes("*") ? (
                    <div className="row">
                            
                        <div className="col mb-3 ms-3">
                            {props.store.SessionStore.buckets.map((bucket) => (    
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    defaultChecked={formData.buckets.includes(bucket.sid)}
                                    value={bucket.sid}
                                    id={`bucket_${bucket.sid}`}
                                    label={bucket.name}
                                    key={`bucket_${bucket.sid}`}
                                    onChange={handleBucketChange} />
                            
                            ))}      
                        </div>
                    </div>    
                ) : ('')}
                        

            <div className="row">
                <div className="col mb-3">
                    <label className="form-label">Environments*</label>
                </div>
            </div>

            <div className="row">
                <div className="col mb-3 ms-3">
                    <Form.Check // prettier-ignore
                            type="switch"
                            id="all-environments"
                            value="*"
                            defaultChecked={formData.environments.includes("*")}
                            label="Apply to all"
                            onChange={handleEnvironmentsChange} />
                </div>
            </div>
                {!formData.environments.includes("*") ? (
                    <div className="row">
                            
                        <div className="col mb-3 ms-3">
                            {props.store.SessionStore.environments.map((environment) => (    
                                <Form.Check // prettier-ignore
                                type="switch"
                                defaultChecked={formData.environments.includes(environment.sid)}
                                value={environment.sid}
                                id={`environment_${environment.sid}`}
                                label={environment.name}
                                key={`environment_${environment.sid}`}
                                onChange={handleEnvironmentsChange}
                            />
                            
                            ))}      
                        </div>
                    </div>    
                ) : ('')}
            
            <hr/>

            {formData.enabled ? (
                <div className="d-flex justify-content-end">
                    {renderButtons()}
                </div>
            ) : (
                <AlertMessage show={!formData.enabled}>
                    <div className="text-center">
                        <div className='mb-3'>This redaction is currently not enabled. It can still be saved but will not be actively redacting data.</div>
                        {renderButtons()}
                    </div>
                </AlertMessage>    
            )}
        </Form>
    </>
  );
});

export default SaveAsExclusion;